import { render, staticRenderFns } from "./manage-old.vue?vue&type=template&id=1e083c82&"
import script from "./manage-old.vue?vue&type=script&lang=js&"
export * from "./manage-old.vue?vue&type=script&lang=js&"
import style0 from "./manage-old.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports